import { h } from "vue";
export const renderSvg = (children) => children.map(
  (child) => child.type === "element" ? h(child.name, child.attributes, renderSvg(child.children)) : child.value
);
